__webpack_require__.p = "/storybook-rating-component-deprecations-/referrals/";